import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center space-y-4 mb-8">
      {/* Logo */}
      <div className="flex justify-center">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-12 h-12 bg-primary rounded-xl">
            <Icon name="Activity" size={28} color="white" />
          </div>
          <span className="text-2xl font-bold text-foreground">
            ServiceWatch
          </span>
        </div>
      </div>

      {/* Welcome Message */}
      <div className="space-y-2">
        <h1 className="text-3xl font-bold text-foreground">
          Welcome Back
        </h1>
        <p className="text-muted-foreground max-w-md mx-auto">
          Sign in to your account to access real-time outage monitoring, personalized alerts, and comprehensive service analytics.
        </p>
      </div>

      {/* Quick Stats */}
      <div className="flex items-center justify-center space-x-6 text-sm text-muted-foreground">
        <div className="flex items-center space-x-1">
          <div className="status-indicator status-online"></div>
          <span>Live Monitoring</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="Users" size={14} />
          <span>50K+ Users</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="Globe" size={14} />
          <span>Global Coverage</span>
        </div>
      </div>

      {/* New User Prompt */}
      <div className="pt-4">
        <p className="text-sm text-muted-foreground">
          Don't have an account?{' '}
          <Link 
            to="/user-registration" 
            className="text-primary hover:text-primary/80 font-medium transition-colors"
          >
            Create one now
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;